import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../lib/api';
import BrandLogo from '../components/BrandLogo';

// Public privacy page for table reservations.
// Reachable without login at /datenschutz and /privacy (alias in App.js).
export default function Datenschutz() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get('/settings/public').then(r => setSettings(r.data || {})).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F9F7] text-[#1C1C19]" data-testid="datenschutz-page">
      <header className="border-b border-[#E5E5E0] bg-white">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/" className="block">
            <BrandLogo settings={settings} className="h-8" />
          </Link>
          <nav className="text-xs text-[#5C5C59] flex gap-4">
            <Link to="/" className="hover:text-[#1C1C19]" data-testid="ds-back-home">Reservierung</Link>
            <Link to="/impressum" className="hover:text-[#1C1C19]" data-testid="ds-impressum-link">Impressum</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="font-display text-3xl md:text-4xl mb-2">Datenschutz bei Tischreservierungen</h1>
        <p className="text-sm text-[#5C5C59] mb-8">Hinweise zur Verarbeitung Ihrer Daten im Rahmen der Tischreservierung.</p>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Verantwortlich</h2>
          <p className="text-sm leading-relaxed">
            Gagliardi Gastronomie GmbH<br />
            Zwinglistraße 22<br />
            01277 Dresden<br />
            Deutschland
          </p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Betrieb</h2>
          <p className="text-sm leading-relaxed">
            La Contadina<br />
            Reisewitzer Straße 49<br />
            01159 Dresden
          </p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Vertreten durch</h2>
          <p className="text-sm leading-relaxed">Giuseppe Gagliardi</p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Welche Daten werden verarbeitet</h2>
          <ul className="list-disc list-inside text-sm leading-relaxed space-y-1">
            <li>Name</li>
            <li>Telefonnummer</li>
            <li>E-Mail-Adresse, falls angegeben</li>
            <li>Datum und Uhrzeit der Reservierung</li>
            <li>Anzahl der Personen</li>
            <li>freiwillige Bemerkungen oder Wünsche</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Zweck der Verarbeitung</h2>
          <p className="text-sm leading-relaxed mb-2">
            Die Daten werden ausschließlich zur Bearbeitung und Durchführung der Tischreservierung verwendet.
          </p>
          <p className="text-sm leading-relaxed mb-1">Die Daten werden genutzt für:</p>
          <ul className="list-disc list-inside text-sm leading-relaxed space-y-1">
            <li>Reservierung eines Tisches</li>
            <li>Kontaktaufnahme bei Rückfragen</li>
            <li>Verwaltung der Tischbelegung</li>
            <li>Benachrichtigung bei Änderungen oder Problemen mit der Reservierung</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Keine Nutzung</h2>
          <ul className="list-disc list-inside text-sm leading-relaxed space-y-1">
            <li>keine Werbung</li>
            <li>kein Newsletter</li>
            <li>kein Verkauf der Daten</li>
            <li>keine Weitergabe an Dritte zu Werbezwecken</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Speicherdauer</h2>
          <p className="text-sm leading-relaxed">
            Reservierungsdaten werden nach Ablauf der vom Restaurant festgelegten Frist automatisch gelöscht oder
            anonymisiert. Standardmäßig beträgt diese Frist 180 Tage nach dem Reservierungsdatum. Die konkrete
            Speicherdauer kann auf Anfrage erfragt werden.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Ihre Rechte</h2>
          <p className="text-sm leading-relaxed">
            Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten sowie das Recht auf Datenübertragbarkeit und Widerspruch. Wenden Sie sich
            hierfür an die oben genannte Adresse oder per E-Mail an
            {settings.restaurant_email ? <> <a className="underline" href={`mailto:${settings.restaurant_email}`}>{settings.restaurant_email}</a></> : ' den Betreiber.'}
          </p>
        </section>

        <div className="mt-12 pt-6 border-t border-[#E5E5E0] flex flex-wrap gap-4 text-xs text-[#5C5C59]">
          <Link to="/" data-testid="ds-footer-home" className="hover:text-[#1C1C19] underline">Zurück zur Reservierung</Link>
          <Link to="/impressum" data-testid="ds-footer-impressum" className="hover:text-[#1C1C19] underline">Impressum</Link>
        </div>
      </main>
    </div>
  );
}
